import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { CambiarcontraComponent } from './components/shared/cambiarcontra/cambiarcontra.component';
import { RegisterComponent } from './components/register/register.component';
import { RecuperarComponent } from './components/shared/recuperar/recuperar.component';
import { AgregarusuariosComponent } from './components/secciones/agregarusuarios/agregarusuarios.component';
import { PerfilComponent } from './components/secciones/perfil/perfil.component';
import { CalendarioComponent } from './components/secciones/calendario/calendario.component';
import { MitrabajoComponent } from './components/secciones/mitrabajo/mitrabajo.component';
import { TareasComponent } from './components/tareas/tareas/tareas.component';
import { InformacionComponent } from './components/tareas/informacion/informacion.component';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent
  },
  { path: '', component: HomeComponent },
  { path: 'actividades', component: TareasComponent },
  { path: 'detalles', component: InformacionComponent },

  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'recovery_password', component: CambiarcontraComponent },
  { path: 'password_reset/:id', component: RecuperarComponent },

  { path: 'calendario', component: CalendarioComponent },
  { path: 'mitrabajo', component: MitrabajoComponent },
  { path: 'perfil', component: PerfilComponent },
  { path: 'agregarusuario', component: AgregarusuariosComponent },
  { path: '**', pathMatch: 'full', redirectTo: 'login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)

  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
